export const APIEndpoints = {
  FetchVendorsList: '/v0/service/vendor/list',
  ValidateThirdPartyVendorToken:
    '/v0/rag/workflows/multi_file_va/vendor/validate-token',
  SendThirdPartyVendorFormEmail:
    '/v0/rag/workflows/multi_file_va/vendor/send-email',
  SubmitThirdPartyVendorForm:
    '/v0/rag/workflows/multi_file_va/vendor/intake-form',  // Fixed missing leading slash
  EvidenceCollectionAuth:
    '/v0/tpra/vendor/authenticate',
  EvidenceUpload:
    '/v0/tpra/evidences/upload',
  PatchEvidence:
    '/v0/tpra/evidences',
  SubmitQuestionnaire:
    '/v0/tpra/questionnaire/submit',
  SubmitQuestionnaireForm:
    '/v0/tpra/questionnaires/submit',
  UpdateIndividualQuestion:
    '/v0/tpra/questionnaires/question/{question_id}',
  RespondOffline:
    '/v0/tpra/questionnaires/respond-offline',
  VendorSessionQuestionnaire:
    '/v0/tpra/questionnaires/vendor-session-questionnaire',
  ChatMessages:
    '/v0/tpra/chat/messages',
  MarkQuestionnaireCompleted:
    '/v0/tpra/questionnaires/mark-completed',
  TPRASummary:
    '/v0/tpra/dashboard/summary',
  TPRADashboardVendors:
    '/v0/tpra/dashboard/vendors',
  TPRADashboardBreachHistory:
    '/v0/tpra/dashboard/breach-history',
  TPRADashboardRisks:
    '/v0/tpra/dashboard/risks',
  // TPRA Home Dashboard endpoints
  TPRAHomeSummary:
    '/v0/tpra/home/summary',
  TPRAHomeAssessmentStages:
    '/v0/tpra/home/assessment-stages',
  TPRAHomeRiskHeatmap:
    '/v0/tpra/home/risk-heatmap',
  TPRAHomeFindingsSummary:
    '/v0/tpra/home/findings-summary',
  TPRAHomeTasks:
    '/v0/tpra/home/tasks',
  TPRAHomeDismissTask:
    '/v0/tpra/home/tasks/{task_id}/dismiss',
  TPRAHomeRecentEvents:
    '/v0/tpra/home/recent-events',
  TPRAAssessments:
    '/v0/tpra/assessments',
  // Tier Mappings endpoint
  TierMappings: '/v0/tpra/tier-mappings',
  // Whitelisted Domains endpoints
  WhitelistedDomains:
    '/v0/orgs/whitelist',
};
